import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import defaultStore from './store';

export type CivilDrawStoreApi = typeof defaultStore;

const CivilDrawStoreContext = createContext<CivilDrawStoreApi>(defaultStore);

export function CivilDrawStoreProvider({ store, children }: { store: CivilDrawStoreApi; children: ReactNode }) {
  return <CivilDrawStoreContext.Provider value={store}>{children}</CivilDrawStoreContext.Provider>;
}

export function useCivilDrawStore(): CivilDrawStoreApi {
  return useContext(CivilDrawStoreContext);
}
